module.exports = __webpack_public_path__ + "media/images/right_arrow-da05fbb7a5afd07bf662a511e4e9e2f8.svg";